/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';


export interface ResourceOnboardStatusInfo { 
    message?: string;
    provider?: ResourceProvider;
    resource_id?: string;
}
export namespace ResourceOnboardStatusInfo {
}


